'use strict';

$(document).on('input', '.scheme-fullname, .scheme-state, .scheme-city, .scheme-gender, .scheme-marital-status, .scheme-account-holder, .scheme-bankname', function () {
    var value = $(this).val();
    value = value
        .replace(/[^a-zA-Z\s]/g, '')
        .replace(/^\s+/, '')
        .replace(/\s{2,}/g, ' ');
    $(this).val(value);
});

$(document).on('blur', '.scheme-account-number', function () {
    var $field = $(this);
    var value = $.trim($field.val());
    var accountRegex = /^[0-9]{9,18}$/;
    var $error = $field.closest('.form-group').find('.invalid-feedback');
    if (value === '') {
        $field.removeClass('is-invalid');
        $error.text('');
        return;
    }

    if (!accountRegex.test(value)) {
        $field.addClass('is-invalid');
        $error.text('Please enter a valid account number.');
    } else {
        $field.removeClass('is-invalid');
        $error.text('');
    }
});

$(document).on('input', '.scheme-account-number', function () {
    var value = $(this).val().replace(/\D/g, '');
    value = value.substring(0, 18);
    $(this).val(value);
});

$(document).on('input', '.scheme-ifsc', function () {
    var value = $(this).val().toUpperCase();
    value = value
        .replace(/[^A-Z0-9]/g, '')
        .substring(0, 11);
    $(this).val(value);
});

$(document).on('blur', '.scheme-ifsc', function () {
    var $field = $(this);
    var value = $.trim($field.val());
    var ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
    var $error = $field.closest('.form-group').find('.invalid-feedback');

    if (value === '') {
        $field.removeClass('is-invalid');
        $error.text('');
        return;
    }

    if (!ifscRegex.test(value)) {
        $field.addClass('is-invalid');
        $error.text('Please enter a valid IFSC code.');
    } else {
        $field.removeClass('is-invalid');
        $error.text('');
    }
});

$(document).on('input', '.scheme-mobile, .scheme-pincode', function () {
    var value = $(this).val().replace(/\D/g, '');
    if ($(this).hasClass('scheme-mobile')) {
        value = value.substring(0, 10);
        if (value.length > 0 && !/^[6-9]/.test(value)) {
            value = '';
        }
    }

    if ($(this).hasClass('scheme-pincode')) {
        value = value.substring(0, 6);
    }
    $(this).val(value);
});

$(document).on('blur', '.scheme-mobile, .scheme-pincode', function () {
    var $field = $(this);
    var value = $.trim($field.val());
    $field.removeClass('is-invalid');
    $field.next('.invalid-feedback').remove();
    if ($field.hasClass('scheme-mobile')) {
        var sameDigits = /^(\d)\1{9}$/;
        if (
            value === ''
            || !/^[6-9]\d{9}$/.test(value)
            || sameDigits.test(value)
        ) {
            $field.addClass('is-invalid');
            let $error = $field.siblings('.invalid-feedback');

            if ($error.length) {
                $error.text('Please enter valid mobile number.');
            } else {
                $field.after('<div class="invalid-feedback">Please enter valid mobile number.</div>');
            }
        }
    }
    if ($field.hasClass('scheme-pincode')) {
        var samePin = /^(\d)\1{5}$/;
        if (value === '' || !/^\d{6}$/.test(value) || samePin.test(value)) {
            $field.addClass('is-invalid');
            let $error = $field.siblings('.invalid-feedback');

            if ($error.length) {
                $error.text('Please enter valid mobile number.');
            } else {
                $field.after('<div class="invalid-feedback">Please enter valid pincode.</div>');
            }
        }
    }
});

$(document).on('input', '.scheme-door-no, .scheme-area, .scheme-bankbranch', function () {
    var value = $(this).val();
    value = value
        .replace(/[^\w\s\-/. ,]/g, '')
        .replace(/^\s+/, '')
        .replace(/\s{2,}/g, ' ');
    $(this).val(value);
});

$(document).on('input', '.scheme-email', function () {
    var value = $(this).val();
    value = value
        .replace(/\s/g, '')
        .replace(/[^\x20-\x7E]/g, '')
        .replace(/^\s+/, '');
    $(this).val(value);
});

$(document).on('blur', '.scheme-email', function () {
    var $field = $(this);
    var value = $.trim($field.val());
    var emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    let $error = $field.closest('.form-group').find('.invalid-feedback');
    if (value === '' || !emailRegex.test(value)) {
        $field.addClass('is-invalid');
        if ($error.length) {
            $error.text('Please enter a valid email address.');
        } else {
            $field.after('<div class="invalid-feedback">Please enter a valid email address.</div>');
        }
    } else {
        $field.removeClass('is-invalid');
        if ($error.length) {
            $error.text('');
        } else {
            $field.next('.invalid-feedback').remove();
        }
    }
});

$(document).on('input', '.scheme-pan', function () {
    var value = $(this).val().toUpperCase();
    value = value.replace(/[^A-Z0-9]/g, '');
    $(this).val(value);
});

$(document).on('input', '.scheme-aadhar', function () {
    var value = $(this).val().replace(/\D/g, '');
    value = value.substring(0, 12);
    $(this).val(value);
});

$(document).on('input', '.scheme-confirm-accno', function () {
    var value = $(this).val().replace(/\D/g, '');
    value = value.substring(0, 18);
    $(this).val(value);
});

$(document).on('blur', '.scheme-confirm-accno', function () {
    var $field = $(this);
    var accountNumber = $.trim($('.scheme-account-number').val());
    var confirmAccountNumber = $.trim($field.val());
    var $error = $field.closest('.form-group').find('.invalid-feedback');
    if (accountNumber === '' && confirmAccountNumber === '') {
        $field.removeClass('is-invalid');
        $error.text('');
        return;
    }

    if (accountNumber !== '' && confirmAccountNumber === '') {
        $field.addClass('is-invalid');
        $error.text('Please confirm account number.');
        return;
    }

    if (accountNumber !== confirmAccountNumber) {
        $field.addClass('is-invalid');
        $error.text('Account number does not match.');
    } else {
        $field.removeClass('is-invalid');
        $error.text('');
    }
});

$(document).on('blur', '.scheme-pan', function () {
    var $field = $(this);
    var value = $.trim($field.val()).toUpperCase();
    var panRegex = /^[A-Z]{3}[PCHABGJLFTEK][A-Z][0-9]{4}[A-Z]$/;
    let $error = $field.closest('.form-group').find('.invalid-feedback');
    if (value === '') {
        $field.addClass('is-invalid');
        $error.text('Please enter PAN number.');
    } else if (!panRegex.test(value)) {
        $field.addClass('is-invalid');
        $error.text('Please enter a valid PAN number.');
    } else {
        $field.removeClass('is-invalid');
        $error.text('');
    }
});

$(document).on('input', '#schemeAmount', function () {
    var rate = parseFloat($('#boardRate').text()) || 0;
    var amount = parseFloat($(this).val());
    if (!amount || !rate) {
        $('#schemeWeight').val('');
        return;
    }
    var grams = amount / rate;
    $('#schemeWeight').val(grams.toFixed(3));
    $('#displayAmount').text('₹' + amount.toFixed(2));
    $('#displayWeight').text(grams.toFixed(3) + ' g');
});

$(document).on('input', '#schemeWeight', function () {
    var rate = parseFloat($('#boardRate').text()) || 0;
    var grams = parseFloat($(this).val());
    if (!grams || !rate) {
        $('#schemeAmount').val('');
        return;
    }

    var amount = grams * rate;
    $('#schemeAmount').val(amount.toFixed(2));
    $('#displayAmount').text('₹' + amount.toFixed(2));
    $('#displayWeight').text(grams.toFixed(3) + ' g');
});

$(document).on('click', '.quick-amounts button', function () {
    var amount = $(this).data('amount');
    $('#schemeAmount').val(amount).trigger('input');
});

$(document).on('submit', '.price-calculator-form', function (e) {
    e.preventDefault();
    $.ajax({
        url: $(this).data('url'),
        type: 'POST',
        data: $(this).serialize(),
        success: function (response) {
            if (response.success) {
                window.location.href = response.redirectUrl;
            }
        }
    });
});
